/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Consent_Revoke_CancelInputs */

const en_us2_body_assessment_consent_revoke_cancel = /** @type {(inputs: Body_Assessment_Consent_Revoke_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leave it as it is`)
};

const pt_br2_body_assessment_consent_revoke_cancel = /** @type {(inputs: Body_Assessment_Consent_Revoke_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deixar como está`)
};

const es_419_body_assessment_consent_revoke_cancel = /** @type {(inputs: Body_Assessment_Consent_Revoke_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dejarlo como está`)
};

const pt_pt2_body_assessment_consent_revoke_cancel = /** @type {(inputs: Body_Assessment_Consent_Revoke_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deixar como está`)
};

const fr_fr2_body_assessment_consent_revoke_cancel = /** @type {(inputs: Body_Assessment_Consent_Revoke_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laisser tel quel`)
};

const de_de2_body_assessment_consent_revoke_cancel = /** @type {(inputs: Body_Assessment_Consent_Revoke_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`So lassen`)
};

const it_it2_body_assessment_consent_revoke_cancel = /** @type {(inputs: Body_Assessment_Consent_Revoke_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lascia così`)
};

/**
* | output |
* | --- |
* | "Leave it as it is" |
*
* @param {Body_Assessment_Consent_Revoke_CancelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_consent_revoke_cancel = /** @type {((inputs?: Body_Assessment_Consent_Revoke_CancelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Consent_Revoke_CancelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_consent_revoke_cancel(inputs)
	if (locale === "es-419") return es_419_body_assessment_consent_revoke_cancel(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_consent_revoke_cancel(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_consent_revoke_cancel(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_consent_revoke_cancel(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_consent_revoke_cancel(inputs)
	return en_us2_body_assessment_consent_revoke_cancel(inputs)
});
export { body_assessment_consent_revoke_cancel as "body-assessment.consent_revoke_cancel" }